export default __webpack_public_path__ + "static/media/AUS.8d508594.png";